import React, { useState, useRef } from "react";
import Button from '../UI/Button/Button';
import { Modal } from 'react-bootstrap';
import EditIcon from '../../Images/Icons/edit.svg';
import ViewIcon from '../../Images/Icons/view.svg';
import classes from './../TrialstatNoto.module.css';
import { Disable } from 'react-disable';
import Card from '../UI/Card/Card';
import InputString from '../UI/Control/InputString';
import SelectList from '../UI/Control/SelectList';
import MultiSelectListNew from '../UI/Control/MultiSelectListNew';
import InputTextarea from '../UI/Control/InputTextarea';
import InputCheckbox from '../UI/Control/InputCheckbox';
import MandatoryLabel from '../UI/Control/MandatoryLabel';
import DeleteIcon from '../../Images/Icons/delete.svg';

const ZeltaStudyModal = (props) => {
    const [show, setShow] = useState(false);
    const handleClose = () => {
        setShow(false);
    };
    const handleShow = () => {
        setSponsorId('-1');
        setSelDiseaseTypeIds([]);
        setArrDelVisitId([]);
        setArrDelVisitIdBK([]);
        setArrVisit([]);
        setCIMSDisabled(true);
        setCIMSStudies([]);
        setCIMSId('0');
        fetchStudyDetail();
        setShow(true);
    };

    const [CIMSDisabled, setCIMSDisabled] = useState('disabled');
    const [sponsorsList, setSponsorsList] = useState([{}]);
    const [phase, setPhase] = useState([{}]);
    const [diseaseTypes, setDiseaseTypes] = useState([]);
    const [cimsStudies, setCIMSStudies] = useState([{ Value: '0', Name: '--CIMS Study--' }]);
    const [CIMSId, setCIMSId] = useState('0');
    const [CHKCIMSIntegration, setCHKCIMSIntegration] = useState(false);
    const [sponsorId, setSponsorId] = useState('-1');
    const [selDiseaseTypeIds, setSelDiseaseTypeIds] = useState([]);
    const refCIMSId = useRef([]);
    const [arrCIMSVisit, setArrCIMSVisit] = useState([]);
    const [arrParadigm, setArrParadigm] = useState([]);
    const [arrVisit, setArrVisit] = useState([]);
    const [arrDelVisitId, setArrDelVisitId] = useState([]);
    const [arrDelVisitIdBK, setArrDelVisitIdBK] = useState([]);
    //store study protocol ID in application store
    //Retrive the state from app store
    const fetchPhases = async () => {
        fetch('api/ZeltaStudy/GetPhases')
            .then(response => response.json())
            .then(data => {
                setPhase(data);
            });
    };
    const fetchSponsorsList = () => {
        fetch('api/ZeltaStudy/GetSponsors')
            .then(response => response.json())
            .then(data => {
                setSponsorsList(data);
            });
    }

    const GetCIMSStudies = (LinkCIMS, CIMSID) => {
        var CIMSarr = [{ Value: "0", Name: "--CIMS Study--" }]
        let ctrCIMS = document.getElementById('chkCIMInteg');
        fetch("api/CIMSServicesCall/GetCIMSStudies")
            .then(response => response.text())
            .then(data => {
                if (data != "") {
                    var CIMSStudies = JSON.parse(data);
                    for (var iCount = 0; iCount < CIMSStudies.length; iCount++) {
                        var retVal = refCIMSId.current.filter((Id) => { return Id == CIMSStudies[iCount] });
                        if (retVal.length == 0 || CIMSID == CIMSStudies[iCount])
                            CIMSarr.push({ Value: CIMSStudies[iCount], Name: CIMSStudies[iCount] });
                    }
                }
                else
                    alert('Error while getting CIMS studies; for details, look into the ErrorLog Table.')

                setCIMSStudies(CIMSarr)
                if (LinkCIMS == 'Y') {
                    document.getElementById('chkCIMInteg').checked = true;
                    setCIMSId(CIMSID);
                }
            })
    }

    const fetchStudyDetail = () => {
        fetchSponsorsList();
        fetchDiseaseTypesList();
        fetchPhases();
        fillCIMSList();
        FillParadigmList();
        if (props.studyId != '') {
            fetch('api/ZeltaStudy/GetZeltaStudyDetail?studyId=' + props.studyId)
                .then(response => response.json())
                .then(data => {
                    setData(data);
                    GetCIMSStudies(data.LinkCIMS, data.CIMSID);
                });
        }
        else {
            GetCIMSStudies('F', "0");
        }
    }
    const fetchDiseaseTypesList = async () => {
        fetch('api/ZeltaStudy/FillDiseaseTypesList')
            .then(response => response.json())
            .then(data => {
                setDiseaseTypes(data);
            });
    }

    function setData(data) {
        document.getElementById('txtStudyShortName').value = data.StudyCode;
        document.getElementById('txtStudyName').value = data.StudyName;
        setSponsorId(data.Sponsor);
        if (data.LinkCIMS == 'Y') {
            document.getElementById('chkCIMInteg').checked = true;
            setCIMSDisabled('');
            document.getElementById('ddlCIMSStudies').value = data.CIMSID;
        }

        document.getElementById('txtStudyDescription').value = data.StudyDesc;
        document.getElementById('txtProtocol').value = data.Protocol;
        document.getElementById('txtProtocolVersion').value = data.ProtocolVersion;
        document.getElementById('ddlPhase').value = data.PhaseID;

        const selDiseaseTypes = data.DiseaseTypeID.split(',');
        setSelDiseaseTypeIds(selDiseaseTypes);
        document.getElementById('txtProtocolCode').value = data.ProtocolCode;
        setCHKCIMSIntegration((props.action == 'add' || props.action == 'edit')? false : true);
        setArrVisit(data.listZeltaVisits);
        FillCIMSVisitList(data.CIMSID);
    }

    const CIMIntegChange = (e) => {
        if (e.target.checked) {
            setCIMSDisabled('');
        }
        else {
            setArrVisit([]);
            setCIMSId('0')
            setCIMSDisabled('disabled');
        }
    };

    const handleSponsor = (e) => {
        setSponsorId(e.target.value);
    };

    const handleCIMSStudies = (e) => {
        setArrVisit([]);
        if (e.target.value != '0') {
            FillCIMSVisitList(e.target.value);
        }
        else {
            setArrCIMSVisit([]);
        }
        setCIMSId(e.target.value);
    };

    const handleDiseaseType = (e) => {
        var objMultiSelect = document.getElementById(e.target.id);
        var multiSelectValue = [...objMultiSelect.selectedOptions].map(option => option.value);
        setSelDiseaseTypeIds(multiSelectValue);
    };

    function ValidateStudySettings() {

        const objSponsor = document.getElementById('ddlSponsors');
        if (sponsorId.trim() == '' || sponsorId.trim() == '-1') {
            alert('Please select Sponsor.');
            objSponsor.focus();
            return false;
        }

        const objStudyName = document.getElementById('txtStudyName');
        if (objStudyName.value.trim() == '') {
            alert('Study name should not be empty.');
            objStudyName.focus();
            return false;
        }

        const objStudyCode = document.getElementById('txtStudyShortName');
        if (objStudyCode.value.trim() == '') {
            alert('Study short name should not be empty.');
            objStudyCode.focus();
            return false;
        }

        let re = new RegExp("^[A-Za-z0-9_]*$");
        if (re.test(objStudyCode.value.trim()) == false) {
            alert('Study short name can only contain alphabetic character, numeric character and "_" , for example: Study_A36. Please change your project name to another.');
            objStudyCode.focus();
            return false;
        }

        if (objStudyCode.value.toLowerCase().endsWith('_prod') || objStudyCode.value.toLowerCase().endsWith('_dev') || objStudyCode.value.toLowerCase().endsWith('_uat')) {
            alert('Study short name filed not allowed _PROD, _DEV, or _UAT as a suffix.');
            objStudyCode.focus();
            return false;
        }

        const objProtocol = document.getElementById('txtProtocol');
        if (objProtocol.value.trim() == '') {
            alert('Protocol should not be empty.');
            objProtocol.focus();
            return false;
        }

        const objDiseaseType = document.getElementById('ddlDiseaseType');
        if (objDiseaseType.value == 0) {
            alert('Please select disease type.');
            objDiseaseType.focus();
            return false;
        }

        const objProtocolCode = document.getElementById('txtProtocolCode');
        if (objProtocolCode.value.trim() == '') {
            alert('Protocol code should not be empty.');
            objProtocolCode.focus();
            return false;
        }

        const objProtocolVersion = document.getElementById('txtProtocolVersion');
        if (objProtocolVersion.value.trim() == '') {
            alert('Protocol version should not be empty.');
            objProtocolVersion.focus();
            return false;
        }

        if (document.getElementById('chkCIMInteg').checked === true) {
            const objCIMSIntegration = document.getElementById('ddlCIMSStudies');
            if (objCIMSIntegration.value.trim() == '0') {
                alert('CIMS integration should not be empty.');
                objCIMSIntegration.focus();
                return false;
            }
        }

        return true;
    }

    const SaveStudySettings = (event) => {
        let retVal = ValidateStudySettings();
        if (retVal == false)
            return false;

        let isCIMS = document.getElementById('chkCIMInteg').checked;

        var selDiseaseType = '';
        var multiSelect = document.getElementById('ddlDiseaseType');
        var multiSelected = [...multiSelect.selectedOptions].map(option => option.value);
        for (var jCount = 0; jCount < multiSelected.length; jCount++) {
            selDiseaseType = selDiseaseType + multiSelected[jCount] + "$";
        }
        selDiseaseType = selDiseaseType.substring(0, (selDiseaseType.length - 1));

        let zeltaStudyModel = {
            StudyID: props.studyId,
            StudyCode: document.getElementById('txtStudyShortName').value,
            StudyName: document.getElementById('txtStudyName').value,
            Sponsor: sponsorId,
            LinkCIMS: isCIMS ? 'Y' : 'N',
            CIMSID: isCIMS ? document.getElementById('ddlCIMSStudies').value : '0',
            StudyDesc: document.getElementById('txtStudyDescription').value,
            Protocol: document.getElementById('txtProtocol').value,
            ProtocolVersion: document.getElementById('txtProtocolVersion').value,
            PhaseID: document.getElementById('ddlPhase').value,
            DiseaseTypeID: selDiseaseType, 
            ProtocolCode: document.getElementById('txtProtocolCode').value,
            delVisitIds: arrDelVisitId.toString(),
            listZeltaVisits : new Array()
        };

        for (var cnt = 0; cnt < arrVisit.length; cnt++) {
            let objVisitName = document.getElementById('txtVisitName_' + cnt);
            if (objVisitName.value.trim() == '') {
                alert('Visit name should not be empty.');
                objVisitName.focus();
                return false;
            }

            const filtered = arrVisit.filter(item => item.VisitName.toLowerCase() == objVisitName.value.toLowerCase());

            if (filtered.length > 1) {
                alert(objVisitName.value + ' visit name already exists.')
                objVisitName.focus();
                return false;
            }

            let objCIMSVisit = document.getElementById('ddlCIMSVisit_' + cnt);
            if (objCIMSVisit.value == '-1') {
                alert('Please select CIMS visit.');
                objCIMSVisit.focus();
                return false;
            }

            let objParadigm = document.getElementById('ddlParadigm_' + cnt);
            if (objParadigm.value.trim() == '-1') {
                alert('Please select paradigm.');
                objParadigm.focus();
                return false;
            }

            zeltaStudyModel.listZeltaVisits.push(
                {
                    Sequence: cnt,
                    VisitId: document.getElementById('hdnVisitId_' + cnt).value,
                    VisitName: objVisitName.value,
                    CIMSVisit: objCIMSVisit.value,
                    ParadigmId: objParadigm.value
                }
            );
        }
        fetch('api/ZeltaStudy/SaveZeltaStudy', {
            method: 'POST',
            headers: { 'Content-type': 'application/json' },
            body: JSON.stringify(zeltaStudyModel)
        }).then(r => r.json()).then(res => {
            if (res == -1) {
                alert('Study not saved, Something went wrong.');
                retVal = false;
            }
            if (res == 0) {
                alert('Study code already exist.');
                retVal = false;
            }
            else if (res == -2) {
                alert('Study name already exist.');
                retVal = false;
            }
            else if (res == -3) {
                alert('Protocol already exist.');
                retVal = false;
            }
            else if (res == -4) {
                alert('CIMS integration already exist.');
                retVal = false;
            }
            else {
                props.fetchData();
                setShow(false);
            }
        })
    };

    const fillCIMSList = async () => {
        fetch('api/ZeltaStudy/GetCIMSList')
            .then(response => response.json())
            .then(data => {
                refCIMSId.current = data;
            });
    };

    const FillParadigmList = () => {
        fetch('api/ZeltaStudy/FillParadigmList')
            .then(response => response.json())
            .then(data => {
                setArrParadigm(data);
            });
    }

    const FillCIMSVisitList = (CIMSId) => {
        fetch('api/CIMSServicesCall/FillCIMSVisitList?CIMSID=' + CIMSId)
            .then(response => response.json())
            .then(data => {
                let arr = new Array();
                arr.push({ Value: '-1', Name: '--Select CIMS Visit--' });
                for (var cnt = 0; cnt < data.visits.length; cnt++) {
                    arr.push({ Value: data.visits[cnt], Name: data.visits[cnt] });
                }
                setArrCIMSVisit(arr);
            });
    }

    const AddCIMSVisit = (e) => {
        const objCIMSIntegration = document.getElementById('ddlCIMSStudies');
        if (objCIMSIntegration.value.trim() == '0') {
            alert('Please select CIMS study.');
            objCIMSIntegration.focus();
            return false;
        }

        let arr = new Array();
        for (var i = 0; i < arrVisit.length; i++) {
            let obj = {
                Sequence: i,
                VisitId: arrVisit[i].VisitId,
                VisitName: arrVisit[i].VisitName,
                CIMSVisit: arrVisit[i].CIMSVisit,
                ParadigmId: arrVisit[i].ParadigmId
            }
            arr.push(obj);
        }
        let obj = {
            Sequence: i,
            VisitId: 0,
            VisitName: '',
            CIMSVisit: '-1',
            ParadigmId: '-1',
        }
        arr.push(obj);
        setArrVisit(arr);
    }

    const VisitChangeHandler = (e) => {
        let arr = e.target.id.split('_');
        let idx = arr[1];
        let ctrlName = arr[0];

        var e1 = document.getElementById(e.target.id);
        let newArray = [];
        if (ctrlName == "txtVisitName") {
            newArray = arrVisit.map(visitItem => {
                if (visitItem.Sequence == idx) {
                    return { ...visitItem, VisitName: e1.value };
                }
                return visitItem;
            });
        }
        else if (ctrlName == "ddlCIMSVisit") {
            newArray = arrVisit.map(visitItem => {
                if (visitItem.Sequence == idx) {
                    return { ...visitItem, CIMSVisit: e1.value };
                }
                return visitItem;
            });
        }
        else if (ctrlName == "ddlParadigm") {
            newArray = arrVisit.map(visitItem => {
                if (visitItem.Sequence == idx) {
                    return { ...visitItem, ParadigmId: e1.value };
                }
                return visitItem;
            });
        }
        setArrVisit(newArray);
    }

    let arrRemVisitId = new Array();
    const DeleteVisitHandler = (e) => {
        let arr = e.target.id.split('_');
        let seq = arr[1];
        document.getElementById("hdnVisitId_" + seq).value != 0 && arrRemVisitId.push(document.getElementById("hdnVisitId_" + seq).value);
        const combined = arrDelVisitIdBK.concat(arrRemVisitId);
        setArrDelVisitIdBK(combined);
        let arrQues = arrVisit.filter(q => q.Sequence != seq);
        arrQues.forEach((item, i) => item.Sequence = i);
        setArrVisit(arrQues);
        setArrDelVisitId(combined);
    }

return (
    <>
        {props.btn === "true" && props.action === "add" && <Button variant="primary" className="btn btn-success" onClick={handleShow} style={{ float: "right" }}> {props.text}  </Button>}
        {props.btn === "icon" && props.action === "edit" && <img className="" style={{ "border": "1px solid #dcdcdc", "cursor": "pointer", marginLeft: "10px" }} height="34px" width="34px" src={EditIcon} alt="Add" title="Edit Study" onClick={handleShow} />}
        {props.btn === "icon" && props.action === "view" && <img className="" style={{ "border": "1px solid #dcdcdc", "cursor": "pointer", marginLeft: "10px" }} height="34px" width="34px" src={ViewIcon} alt="Add" title="Edit Study" onClick={handleShow} />}
        <Modal show={show} onHide={handleClose} dialogClassName={classes.TSModalDailog_95pc} animation={false} backdrop="static">
            <Modal.Header closeButton>
                <Modal.Title>{props.header}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Card>
                    <Disable disabled={props.disabled}>

                        <div className="row">
                            <div className="col-sm-1"></div>
                            <div className="col-sm-10">
                                <div style={{ fontWeight: "bold" }}>
                                    Study Settings
                             <hr style={{ color: "gray", margin: "0px" }} />
                                </div>

                                <div className="row mb-3 mt-3">
                                    <div className="col-sm-6">
                                        <div className="row">
                                            <div className="col-md-3">
                                                <label htmlFor="">Sponsor:</label>
                                                <MandatoryLabel></MandatoryLabel>
                                            </div>
                                            <div className="col-md-9" style={{ paddingLeft: "7px", width: "73.5%" }}>
                                                <SelectList dataSource={sponsorsList} id="ddlSponsors" onChangeHandler={handleSponsor} value={sponsorId}></SelectList>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-sm-6">
                                        <div className="row">
                                            <div className="col-md-3">
                                                <label htmlFor="">Study Name:</label>
                                                <MandatoryLabel></MandatoryLabel>
                                            </div>
                                            <div className="col-md-9" style={{ paddingLeft: "0px", width: "72%" }}>
                                                <InputString id="txtStudyName" maxlength="50"></InputString>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-1"></div>
                        </div>
                        <div className="row">
                            <div className="col-sm-1"></div>
                            <div className="col-sm-10">
                                <div className="row mb-3">
                                    <div className="col-sm-6">
                                        <div className="row">
                                            <div className="col-md-3">
                                                <label htmlFor="">Study Short Name:</label>
                                                <MandatoryLabel></MandatoryLabel>
                                            </div>
                                            <div className="col-md-9" style={{ paddingLeft: "7px", width: "73.5%" }}>
                                                <InputString id="txtStudyShortName" maxlength="10"></InputString>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-sm-6">
                                        <div className="row">
                                            <div className="col-md-3">
                                                <label htmlFor="">Protocol:</label>
                                                <MandatoryLabel></MandatoryLabel>
                                            </div>
                                            <div className="col-md-9" style={{ paddingLeft: "0px", width: "72%" }}>
                                                <InputString id="txtProtocol" maxlength="64"></InputString>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-1"></div>
                            </div>
                            <div className="row">
                                <div className="col-sm-1"></div>
                                <div className="col-sm-10">
                                    <div className="row mb-3">
                                        <div className="col-sm-6">
                                            <div className="row mb-3">
                                                <div className="col-md-3">
                                                    <label htmlFor="">Study Description:</label>
                                                </div>
                                                <div className="col-md-9">
                                                    <InputTextarea id="txtStudyDescription" rows="3" maxlength="750"></InputTextarea>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-3">
                                                    <label htmlFor="">Phase:</label>
                                                </div>
                                                <div className="col-md-9">
                                                    <SelectList dataSource={phase} id="ddlPhase"></SelectList>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-sm-6">
                                            <div className="row">
                                                <div className="col-md-3">
                                                    <label htmlFor="" style={{ marginLeft: "10px" }}>Disease Type:</label>
                                                    <MandatoryLabel></MandatoryLabel>
                                                </div>
                                                <div className="col-md-9">
                                                    <MultiSelectListNew dataSource={diseaseTypes} size="6" id="ddlDiseaseType" onChangeHandler={handleDiseaseType} selectedData={selDiseaseTypeIds}></MultiSelectListNew>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-1"></div>
                            </div>
                            <div className="row">
                                <div className="col-sm-1"></div>
                                <div className="col-sm-10">
                                    <div className="row">
                                        <div className="col-sm-6">
                                            <div className="row">
                                                <div className="col-md-3">
                                                    <label htmlFor="">Protocol Code:</label>
                                                    <MandatoryLabel></MandatoryLabel>
                                                </div>
                                                <div className="col-md-9">
                                                    <InputString id="txtProtocolCode" maxlength="250"></InputString>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-sm-6">
                                            <div className="row">
                                                <div className="col-md-3">
                                                    <label htmlFor="" style={{ marginLeft: "10px" }}>Protocol Version:</label>
                                                    <MandatoryLabel></MandatoryLabel>
                                                </div>
                                                <div className="col-md-9">
                                                    <InputString id="txtProtocolVersion" maxlength="64"></InputString>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-1"></div>
                            </div>

                            <div className="row">
                                <div className="col-sm-1"></div>
                                <div className="col-sm-10">
                                    <div style={{ fontWeight: "bold" }}>
                                        Integration
                                 <hr style={{ color: "gray", margin: "0px" }} />
                                    </div>
                                    <div className="row mb-3 mt-3">
                                        <div className="col-sm-6">
                                            <div className="row">
                                                <div className="col-md-3">
                                                    <label htmlFor="">CIMS Integration:</label>
                                                </div>
                                                <div className="col-md-7">
                                                    <div className="input-group">                                                        
                                                        <InputCheckbox id="chkCIMInteg" name="chkCIMInteg" onChange={CIMIntegChange} style={{ marginTop: "10px" }} disabled={CHKCIMSIntegration}></InputCheckbox>
                                                        <SelectList dataSource={cimsStudies} disabled={CIMSDisabled} id="ddlCIMSStudies" style={{ marginLeft: "10px" }} onChangeHandler={handleCIMSStudies} value={CIMSId} ></SelectList>
                                                       
                                                    </div>
                                                </div>
                                                <div className="col-md-2">
                                                   
                                                </div>
                                                
                                            </div>
                                        </div>
                                        <div className="col-sm-6">
                                            <div className="row">
                                                <div className="col-sm-12">
                                                    {(props.action == 'add' || props.action == 'edit') &&
                                                        <Button id="btnAddCIMSVisit" className="btn btn-success" onClick={AddCIMSVisit} disabled={CIMSDisabled} style={{ float: "right" }}> Add Visit </Button>}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-1"></div>
                            </div>
                            {
                                arrVisit.length > 0 && <div className="row">
                                    <div className="col-sm-1"></div>
                                    <div className="col-sm-10">
                                        <div id="divVisitList">
                                            <div className={"row " + classes.rowstriped} style={{ borderTopStyle: "solid", borderWidth: "thin", borderColor: "silver", backgroundColor: "rgb(131, 192, 220)", color: "white", fontWeight: "bold", textAlign: "center" }}>
                                                <div className="col-sm-4 d-flex justify-content-center text-center"> Visit Name</div>
                                                <div className="col-sm-3 d-flex justify-content-center text-center">CIMS Visit Name</div>
                                                <div className="col-sm-3 d-flex justify-content-center text-center">Paradigm</div>
                                                {(props.action == 'add' || props.action == 'edit') &&
                                                    <div className="col-sm-2 d-flex justify-content-center text-center"> Action</div>}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-sm-1"></div>
                                </div>
                            }
                            {
                                arrVisit.map((item, index) =>
                                <div className="row">
                                    <div className="col-sm-1"></div>
                                    <div className="col-sm-10">
                                        <div id="divVisitList">
                                                <div className={"row " + classes.rowstriped} style={{ borderTopStyle: "solid", borderWidth: "thin", borderColor: "silver" }}>
                                                    <input type="hidden" id={"hdnVisitId_" + item.Sequence} value={item.VisitId} />
                                                    <div className="col-sm-4 d-flex justify-content-center text-center">
                                                        <InputString id={"txtVisitName_" + item.Sequence} value={item.VisitName} maxlength="50" onChangeHandler={VisitChangeHandler}></InputString>
                                                </div>
                                                <div className="col-sm-3 d-flex justify-content-center text-center">
                                                        <SelectList dataSource={arrCIMSVisit} id={"ddlCIMSVisit_" + item.Sequence} value={item.CIMSVisit} onChangeHandler={VisitChangeHandler}></SelectList>
                                                </div>
                                                    <div className="col-sm-3 d-flex justify-content-center text-center">
                                                        <SelectList dataSource={arrParadigm} id={"ddlParadigm_" + item.Sequence} value={item.ParadigmId} onChangeHandler={VisitChangeHandler}></SelectList>
                                                </div>
                                                    {(props.action == 'add' || props.action == 'edit') && <div className="col-sm-2 d-flex justify-content-center text-center">

                                                        <img id={"imgDelete_" + item.Sequence} style={{ "border": "1px solid #dcdcdc", "cursor": "pointer", marginLeft: "5px", "float": "right" }}
                                                            height="34px" width="34px" src={DeleteIcon} alt="Delete CIMS Visit" title="Delete CIMS Visit" onClick={DeleteVisitHandler} />
                                                </div>}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-sm-1"></div>
                                    </div>
                                )
                            }
                        </div>
                    </Disable>
                </Card>
            </Modal.Body>
            <Modal.Footer>
                {(props.action == 'add' || props.action == 'edit') && <Button variant="secondary" className="btn btn-success" onClick={SaveStudySettings}> Submit </Button>}
                <Button variant="primary" className="btn btn-danger" onClick={handleClose}>Close</Button>
            </Modal.Footer>
        </Modal>
    </>
);
}
export default ZeltaStudyModal;